module.exports = __webpack_public_path__ + "static/media/padlock-icon.ab52fc6c.svg";